import React, { useState } from 'react';
import { Icon } from '../../components/Icon';
import { Pagination } from '../../components/ui/Pagination';
import type { Person } from '../../types/person';

interface TableProps {
  data: Person[];
  loading: boolean;
  currentPage: number;
  totalPages: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onRefresh: () => void;
  onStateChange: (state: number, employee_id: string) => void;
  updating: boolean
}

export const Table: React.FC<TableProps> = ({
  data,
  loading,
  currentPage,
  totalPages,
  pageSize,
  total,
  onPageChange,
  onRefresh,
  onStateChange,
  updating
}) => {

  const [updatePersonId, setUpdatePersonId] = useState("");
  // const handleView = (empleado: Empleado) => {
  //   alert(`Ver detalles de: ${empleado.nombre}`);
  //   // Implementar navegación a vista de detalles
  // };

  // const handleEdit = (empleado: Empleado) => {
  //   alert(`Editar empleado: ${empleado.nombre}`);
  //   // Implementar navegación a formulario de edición
  // };

  const handleStatus = (state: string | null, employee_id: string | null) => {
    if (!state || !employee_id)
      return
    if (state !== '1' && state !== '2')
      return

    const newState = state === '1' ? 2 : 1;
    setUpdatePersonId(employee_id)
    onStateChange(newState, employee_id);
  }

  // const handleDelete = async (empleado: Empleado) => {
  //   if (window.confirm(`¿Estás seguro de eliminar a ${empleado.nombre}?`)) {
  //     try {
  //       // Aquí iría la llamada a la API para eliminar
  //       // await visitasApi.deleteEmpleado(empleado.id);
  //       alert(`Empleado ${empleado.nombre} eliminado`);
  //       onRefresh();
  //     } catch (error) {

  //       alert(`Error al eliminar el empleado: ${error}`);
  //     }
  //   }
  // };

  return (
    <div className="card p-1 lg:p-4">
      <div className="p-6 border-b border-gray-200 dark:border-gray-700">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            Lista de Usuarios
          </h3>
          <button
            onClick={onRefresh}
            disabled={loading}
            className="flex items-center px-3 py-2 text-sm bg-gray-50 dark:bg-gray-600 font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors disabled:opacity-50"
          >
            <Icon name={loading ? "loading" : "refresh"} className={`w-4 h-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
            Sincronizar
          </button>
        </div>
      </div>

      <div className="overflow-x-auto ">
        <table className="w-full border border-gray-200 ">
          <thead className="bg-gray-50 dark:bg-gray-700 ">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Usuario
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Proveedor
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Estado
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {loading ? (
              <tr>
                <td colSpan={7} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                    <span className="text-gray-600 dark:text-gray-300">Cargando visitas...</span>
                  </div>
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <Icon name="users" className="w-12 h-12 text-gray-400" />
                    <span className="text-gray-500 dark:text-gray-400 text-lg">
                      No se encontraron visitas
                    </span>
                    <span className="text-gray-400 dark:text-gray-500 text-sm">
                      Intenta ajustar los filtros de búsqueda
                    </span>
                  </div>
                </td>
              </tr>
            ) : (
              data.map((person) => (
                <tr
                  key={person.personas_id}
                  className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150"
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="w-16 h-16 rounded-lg flex items-center justify-center overflow-hidden">
                        {person?.url_photo_digital ? (
                          <img
                            src={person.url_photo_digital}
                            alt={`${person.name_persona} ${person.apellido_persona}`}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full bg-gray-300 dark:bg-gray-600 rounded-lg flex items-center justify-center">
                            <Icon name="user" className="w-12 h-12 text-gray-400" />
                          </div>
                        )}
                      </div>

                      <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900 dark:text-white">
                          {person.name_persona} {person.apellido_persona}
                        </div>
                        <div className="text-sm text-gray-500 dark:text-gray-400">
                          {person.numero_persona}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900 dark:text-white">
                      {person.proveedor}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">

                    <button
                      onClick={() => handleStatus(person.status_persona_id, person.numero_persona)}
                      className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${person.status_persona_id === '1'
                        ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                        : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                        }`}
                      title="status"
                    >
                      {updating && updatePersonId === person.numero_persona ? (
                        <>
                          <Icon name="loading" className="w-4 h-4 animate-spin" />
                        </>
                      ) : (
                        <>
                        </>
                      )}

                      {person.status_persona_id === '1' ? "Activo" : "Inactivo"}
                    </button>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex items-center justify-center space-x-2">
                      

                      {/* <button
                        className="p-2 text-green-600 hover:text-green-900 hover:bg-green-50 dark:text-green-400 dark:hover:text-green-300 dark:hover:bg-green-900/20 rounded-lg transition-colors"
                        title="Editar"
                      >
                        <Icon name="edit" className="w-4 h-4" />
                      </button>
                      <button
                        className="p-2 text-red-600 hover:text-red-900 hover:bg-red-50 dark:text-red-400 dark:hover:text-red-300 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                        title="Eliminar"
                      >
                        <Icon name="trash" className="w-4 h-4" />
                      </button> */}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      {totalPages > 1 && (
        <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            pageSize={pageSize}
            total={total}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};